import {
  NEXT_PUBLIC_API_URL,
  NEXT_PUBLIC_ROGUE,
  NEXT_PUBLIC_CREDENTIALS_URL,
  NEXT_PUBLIC_MS_SKILL_MATCHER,
} from "@/config/env";

export const commonApiCalls = {
  server: {
    header: `${NEXT_PUBLIC_API_URL}/api/bff/org/optimized-header/`,
    skill_matcher: {
      companyInfo: (companySlug: string) =>
        `${NEXT_PUBLIC_MS_SKILL_MATCHER}/skill-matcher/v1/company/?slug=${companySlug}`,
    },
    skillMatcherDashboard: {
      companyInfo: (companySlug: string) =>
        `${NEXT_PUBLIC_MS_SKILL_MATCHER}/skills-matcher/v1/dashboard/slugs/?slug=${companySlug}`,
      globalAreasInfo: (companySlug: string) =>
        `${NEXT_PUBLIC_MS_SKILL_MATCHER}/skills-matcher/v1/dashboard/results/?slug=${companySlug}`,
    },
    user: {
      info: `${NEXT_PUBLIC_API_URL}/api/v1/components/headerv2/user/`,
    },
    company: {
      details: (companyId: string) => `${NEXT_PUBLIC_API_URL}/api/b2b-v1/settings/${companyId}/details/`,
    },
  },
  client: {
    authorizer: `${NEXT_PUBLIC_CREDENTIALS_URL}/api/v5/users/credentials/`,
    skill_matcher: {
      generateLP: `${NEXT_PUBLIC_MS_SKILL_MATCHER}/skill-matcher/v1/generate/`,
      getLpById: (slug: string, userId: string) =>
        `${NEXT_PUBLIC_MS_SKILL_MATCHER}/skill-matcher/v1/student/?slug=${slug}&id=${userId}`,
      getLpByEmail: (slug: string, userEmail: string) =>
        `${NEXT_PUBLIC_MS_SKILL_MATCHER}/skill-matcher/v1/student/?slug=${slug}&email=${userEmail}`,
    },
    skillMatcherDashboard: {
      getAreaInfo: (slug: string, team: string) =>
        `${NEXT_PUBLIC_MS_SKILL_MATCHER}/skills-matcher/v1/dashboard/results/?slug=${slug}&team=${team}`,
    },
    learningPath: {
      save: `${NEXT_PUBLIC_ROGUE}/api/v3/userlearningpaths/`,
    }
  },
};
